// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"g2-z"};